import { call, put, all, takeEvery, takeLatest, select } from 'redux-saga/effects';

import handleError, { handleSuccess } from 'utils/handleError';
import { ReconciliationActionTypes, setReconciliations, setReconciliation, setSuccess, setLoading,setDayDetails, setReconciliationsListDays, setLoadingDaysList, setLoadingWebhook, setWebhookDetails, setLoadingListWebhookInvocations, seListWebhookInvocations } from '../reducers/reconciliation.reducer.js';

import * as WebApi from "utils/web-api"
import { loadingStart, loadingStop } from 'store/reducers/loading.reducer.js';
import { uploadFile } from 'utils/functions.js';
import { toast } from 'react-toastify';


function* saveUrlFile({ payload }) {
  try {
    yield put(setSuccess(false))
    yield put(loadingStart());

    const token = yield select(state => state.Auth.token);

    const response = yield call(WebApi.uploadUrlFileReconciliation, {
      "Content-Type": "application/x-ofx", "Content-Length": payload?.size, filename: payload?.name
    }, token);

    yield call(uploadFile, response.url, response.fields, payload)

    const reconciliation = yield call(WebApi.saveFileReconciliation, response.fields.key, token)

    yield put(setReconciliation(reconciliation));
    yield put({
      type: ReconciliationActionTypes.ASYNC_RECONCILIATIONS,
      payload: { page: 0, pageSize: 10 },
    });

    handleSuccess('Arquivo enviado com sucesso, iremos analisar o extrato');
    yield put(setSuccess(true))
  } catch (error) {
    if(error?.response?.status === 400) {
      return handleError('Arquivo OFX inválido. Por favor, corrija o arquivo e tente novamente.')
    }
    handleError('Ocorreu um erro inesperado, não foi possível enviar o arquivo');
  } finally {
    yield put(loadingStop());
  }
}

function* asyncListWebhookInvocations({payload}) {
  const { page, pageSize } = payload;

  try {
    yield put(setLoadingListWebhookInvocations(true));
    const token = yield select(state => state.Auth.token);

    const response = yield call(WebApi.listWebhooksInvocations, token, page, pageSize)

    yield put(seListWebhookInvocations(response));
  } catch (error) {
    handleError();
  } finally {
    yield put(setLoadingListWebhookInvocations(false));
  }
}

function* asyncReconciliation({payload}) {
  try {
    yield put(setLoading(true));
    const token = yield select(state => state.Auth.token);
    const response = yield call(WebApi.getReconciliation, token, payload.id);

    const conciliationDays = yield call(WebApi.getReconciliationDays, token, payload.id)

    const formattedResponse = {
      ...response,
      days: conciliationDays
    }

    yield put(setReconciliation(formattedResponse));
  } catch (error) {
    handleError();
  } finally {
    yield put(setLoading(false));
  }
}

function* asyncReconciliationDayDetails({payload}) {
  try {
    yield put(setLoading(true));
    const token = yield select(state => state.Auth.token);
    const response = yield call(WebApi.getReconciliationDayDetails, token, payload.id);
    const conciliationName = yield call(WebApi.getReconciliation, token, response.job);

    const formattedResponse = {
      file_name: conciliationName.file_name,
      ...response
    }

    yield put(setDayDetails(formattedResponse));
    yield;
  } catch (error) {
    handleError();
  } finally {
    yield put(setLoading(false));
  }
}

function* asyncReconciliations({ payload }) {
  const { page, pageSize } = payload;
  try {
    yield put(setLoading(true));
    const token = yield select(state => state.Auth.token);
    const response = yield call(WebApi.getReconciliations, token, page, pageSize)
    yield put(setReconciliations(response))
  } catch (error) {
    handleError()
  } finally {
    yield put(setLoading(false));
  }
}

function* asyncReconciliationsDaysList({ payload }) {
  const { page, pageSize, dayMin, dayMax } = payload;
  try {
    yield put(setLoadingDaysList(true));
    const token = yield select(state => state.Auth.token);
    const response = yield call(WebApi.getReconciliationsDaysList, token, page, pageSize, dayMin, dayMax)
    yield put(setReconciliationsListDays(response))
  } catch (error) {
    handleError()
  } finally {
    yield put(setLoadingDaysList(false));
  }
}

function* asyncWebhooksDetails() {
  try {
    yield put(setLoadingWebhook(true));
    const token = yield select(state => state.Auth.token);
    const response = yield call(WebApi.getWebhooks, token)
    yield put(setWebhookDetails(response))
  } catch (error) {
    if(error?.response?.status === 404) {
      return;
    }
    handleError()
  } finally {
    yield put(setLoadingWebhook(false));
  }
}

function* asyncWebhooksPut({payload}) {
  const { data, isEditing } = payload;

  try {
    yield put(setLoadingWebhook(true));
    const token = yield select(state => state.Auth.token);
    const response = yield call(WebApi.putWebhooks, token, data)
    yield put(setWebhookDetails(response))

    if(isEditing) {
      toast.success('Webhook atualizado com sucesso')
    } else {
      toast.success('Webhook configurado com sucesso')
    }
  } catch (error) {
    handleError()
  } finally {
    yield put(setLoadingWebhook(false));
  }
}


function* asyncWebhooksDelete() {
  try {
    yield put(setLoadingWebhook(true));
    const token = yield select(state => state.Auth.token);
    const response = yield call(WebApi.deleteWebhooks, token)
    yield put(setWebhookDetails(response))

    toast.success('Webhook excluído com sucesso')
  } catch (error) {
    handleError()
  } finally {
    yield put(setLoadingWebhook(false));
  }
}

export default function* MySaga() {
  yield all([
      yield takeEvery(ReconciliationActionTypes.ASYNC_UPLOAD_URl_FILE, saveUrlFile),
      yield takeEvery(ReconciliationActionTypes.ASYNC_RECONCILIATIONS, asyncReconciliations),
      yield takeEvery(ReconciliationActionTypes.ASYNC_RECONCILIATION, asyncReconciliation),
      yield takeEvery(ReconciliationActionTypes.ASYNC_DAY_DETAILS, asyncReconciliationDayDetails),
      yield takeLatest(ReconciliationActionTypes.ASYNC_RECONCILIATIONS_DAYS_LIST, asyncReconciliationsDaysList),
      yield takeEvery(ReconciliationActionTypes.ASYNC_WEBHOOKS_DETAILS, asyncWebhooksDetails),
      yield takeLatest(ReconciliationActionTypes.ASYNC_WEBHOOK_PUT, asyncWebhooksPut),
      yield takeLatest(ReconciliationActionTypes.ASYNC_WEBHOOK_DELETE, asyncWebhooksDelete),
      yield takeLatest(ReconciliationActionTypes.ASYNC_LIST_WEBHOOK_INVOCATION, asyncListWebhookInvocations),
  ]);
}
